import React from 'react';
import { useSelector } from 'react-redux';

import {
  blacklistedManageMenteeStageSelector,
  BLACKLIST_MANAGE_MODAL_STAGES,
} from 'features/communicationManagement';
import PersonalisedMenteeEmailersManageConfirmModal from '../PersonalisedMenteeEmailersManageConfirmModal';
import PersonalisedMenteeEmailersManageLearnerModal from '../PersonalisedMenteeEmailersManageLearnerModal';

export default function PersonalisedMenteeEmailersManageModalRenderer() {
  const manageModalStage = useSelector(blacklistedManageMenteeStageSelector);

  switch (manageModalStage) {
    case BLACKLIST_MANAGE_MODAL_STAGES.manage:
      return <PersonalisedMenteeEmailersManageLearnerModal />;
    case BLACKLIST_MANAGE_MODAL_STAGES.manageConfirmation:
      return <PersonalisedMenteeEmailersManageConfirmModal />;
    default:
      return null;
  }
}
